import {Form, InputNumber} from 'antd';

export function Frequency() {
    return (
        <Form.Item
            label={'Every'}
            name={'frequency'}
            rules={[{required: true, message: 'Please input the frequency'}]}
        >
            <InputNumber
                className={'full-width'}
                id={'frequency'}
                inputMode={'numeric'}
                controls={true}
                min={1}
                step={1}
            />
        </Form.Item>
    )
}
